export default __webpack_public_path__ + "static/media/coupon_sent.f9291879.png";